<div class="auditoria-header">
  <div class="auditoria-header__accent"></div>
  <div class="container auditoria-header__inner">
    <span class="material-icons auditoria-header__icon">timeline</span>
    <div>
      <h1 class="auditoria-header__title">Auditoría · <span>Inscripción</span></h1>
      <p class="auditoria-header__subtitle">Timeline del intento de inscripción</p>
    </div>
  </div>
</div>

<app-spinner
    [show]="!flagLoaded"
    [type]="'fullscreen'"
    [size]="'large'"
    [color]="'#B1476A'"
    [trackColor]="'#4CA7C8'"
    [text]="'Cargando intento...'"
    [showText]="true"
    [blurBackground]="true">
</app-spinner>

<div *ngIf="!flagLoaded" style="height: 100vh;"></div>

<div *ngIf="flagLoaded" class="auditoria-area auditoria-animate-in">
  <div class="container">
    <div class="acciones-top">
      <button mat-stroked-button class="btn-volver" (click)="volver()">
        <mat-icon>arrow_back</mat-icon> Volver al listado
      </button>
    </div>

    <div class="no-data" *ngIf="!evento">
      No se encontró el registro solicitado.
    </div>

    <div class="detalle-card" *ngIf="evento">
      <h3>Referencias</h3>
      <div class="grid-datos">
        <div class="dato">
          <span class="k">Solicitud (FK)</span>
          <span class="v mono">{{ solicitudDeEvento(evento) || '-' }}</span>
        </div>
        <div class="dato">
          <span class="k">Trace ID</span>
          <span class="v mono">{{ evento.traceId || '-' }}</span>
        </div>
        <div class="dato"><span class="k">Email</span><span class="v">{{ evento.email || emailDeEvento(evento) }}</span></div>
        <div class="dato"><span class="k">Usuario ID</span><span class="v mono">{{ evento.usuarioId || evento.usuario?.id || '-' }}</span></div>
      </div>

      <h3>Timeline del intento ({{ timeline.length }} eventos)</h3>
      <ul class="timeline">
        <li class="timeline__item" *ngFor="let e of timeline"
            [ngClass]="e.resultado === 'ERROR' ? 'timeline__item--error' : 'timeline__item--ok'">
          <span class="material-icons timeline__icon">{{ iconoAccionInscripcion(e.accion) }}</span>
          <div class="timeline__body">
            <div class="timeline__head">
              <strong>{{ labelAccionInscripcion(e.accion) }}</strong>
              <span class="timeline__fecha">{{ e.fecha | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
            </div>
            <div class="timeline__resumen" *ngIf="resumenEvento(e)">{{ resumenEvento(e) }}</div>
          </div>
        </li>
      </ul>

      <h3>Último evento</h3>
      <div class="grid-datos">
        <div class="dato"><span class="k">Paso</span><span class="v">{{ labelAccionInscripcion(evento.accion) }}</span></div>
        <div class="dato">
          <span class="k">Resultado</span>
          <span class="v">
            <span class="chip" [ngClass]="evento.resultado === 'ERROR' ? 'chip--error' : 'chip--ok'">
              {{ evento.resultado || 'EXITO' }}
            </span>
            <span *ngIf="evento.status"> ({{ evento.status }})</span>
          </span>
        </div>
        <div class="dato"><span class="k">Fecha</span><span class="v">{{ evento.fecha | date: 'dd/MM/yyyy HH:mm:ss' }}</span></div>
        <div class="dato"><span class="k">Tiempo total (suma de pasos)</span><span class="v">{{ duracionTotalTexto }}</span></div>
      </div>

      <h3>Origen</h3>
      <div class="grid-datos">
        <div class="dato"><span class="k">IP</span><span class="v">{{ evento.ip || '-' }}</span></div>
        <div class="dato dato--full"><span class="k">User Agent</span><span class="v">{{ evento.userAgent || '-' }}</span></div>
      </div>

      <h3 *ngIf="payloadEntries.length">Datos adicionales</h3>
      <div class="grid-datos" *ngIf="payloadEntries.length">
        <div class="dato" *ngFor="let item of payloadEntries">
          <span class="k">{{ item.clave }}</span>
          <span class="v">{{ item.valor }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
